
import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";
import { FormikValues } from 'formik';
import { error } from 'console';
import { processPost } from '../../../../services/api';



export class eventSubscriptionDto extends Dto {
  constructor() {

    super();
    this.data.initialValues = {

      fk_eventcat: '',
      channels: [],
      servers: '',
      analysisTypes:'',
      device: {value: '', label: 'All'},
      params:{}
    }

    this.data.validationSchema = Yup.object({
      fk_eventcat: Yup.object().required("GENERIC.ERRORS.REQUIRED"),
      servers: Yup.array().required("GENERIC.ERRORS.REQUIRED"),
      analysisTypes: Yup.object().required("GENERIC.ERRORS.REQUIRED"),
    });

  }

  async otherValidation(values: FormikValues, id: number | null) {

    // 
    let errors: any = {};

    if (values.channels.length === 0) {
      errors.channels = "GENERIC.ERRORS.REQUIRED";
    } else {
      for (let c of values.channels) {
        if (!c.channelValue) {
          errors.channels = {error:"SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_CHANNEL_REQUIRED", channel: c.channel_type_code};
        }else if(c.channel_type_code === 'email'){
          /*
          const valid = await Yup.string().email().isValid(c.channelValue);
          console.log(valid);
          if(!valid){
            errors.channels = {error:"SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_CHANNEL_VALID_EMAIL", channel: c.channel_type_code};
          }
            */
         
        }
      }
    }


    if(values.analysisTypes.value === "no_alarm_return"){
      if(!values.params.hours || values.params.hours === 0){
        errors.params = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_ALARM_NOT_RETURNED_AFTER_REQUIRED";
      }
    }
    if(values.analysisTypes.value === "occurrencies_in_timeframe"){
      if(!values.params.occurencies || values.params.occurencies === 0){
        errors.params = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_OCCURRENCIES_REQUIRED";
      }else if(!values.params.hours || values.params.hours === 0){
        errors.params = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_HOURS_REQUIRED";
      }
    }

    if(values.analysisTypes.value === "keyword"){
      if(!values.params.keywords || values.params.keywords === ''){
        errors.params = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_KEYWORDS_REQUIRED";
      }
    } 
   

    let fk_eventcat = values.fk_eventcat && values.fk_eventcat.value ? values.fk_eventcat.value : null;
    if(values.analysisTypes.value === "realtime_return"){
      if(![9999, 300, 303, 309,502,503,302, 509,507].includes(fk_eventcat)){
        errors.fk_eventcat = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_EVENT_CAT_NOT_ALLOWED";
      }
    }
    if (fk_eventcat && fk_eventcat !== '0') {
      let result:any = await processPost('system-settings/event-subscription/check-subscription-unique', { fk_eventcat: fk_eventcat, id });
      if(result.data.is_duplicate){
        errors.fk_eventcat = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_EVENT_CAT_UNIQUE";
      }
    }
   




    let analysis_type_code = values.analysisTypes && values.analysisTypes.value ? values.analysisTypes.value : null;
    if (fk_eventcat && fk_eventcat !== '0' && analysis_type_code) {

      let result:any = await processPost('system-settings/event-subscription/check-subscription-allowed', { fk_eventcat, analysis_type_code });
      if(!result.data.is_allowed){
        errors.fk_eventcat = "SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ERRORS_EVENT_NOT_ALLOWED";
      }

    }
    return errors;
  }
}